import React from "react";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import styled from "styled-components";

const getLicenseType = () => {
  try {
    const storedUser = JSON.parse(localStorage.getItem("user") || "null");
    const userLicense = storedUser?.LicenseType || storedUser?.licenseType;
    if (userLicense) return String(userLicense).trim().toUpperCase();
  } catch {
    // Fall back to the signed token below.
  }

  try {
    const token = localStorage.getItem("token");
    if (!token) return "";
    return String(jwtDecode(token)?.LicenseType || "")
      .trim()
      .toUpperCase();
  } catch {
    return "";
  }
};

const ImportLicenseGuard = ({ component: Component, featureName = "Ta funkcja" }) => {
  const isBasicDemo = getLicenseType() === "BASIC_DEMO";

  if (!isBasicDemo) return <Component />;

  return (
    <Page>
      <Card role="alert">
        <LockIcon aria-hidden="true">🔒</LockIcon>
        <h1>{featureName} — funkcja zablokowana</h1>
        <p>
          Aby odblokować tę funkcję, zarejestruj pełne konto demo.
        </p>
        <RegisterButton to="/register-demo">
          Zarejestruj pełne konto DEMO
        </RegisterButton>
        <BackButton to="/sprzedaz/dashboard">
          Wróć do aplikacji
        </BackButton>
      </Card>
    </Page>
  );
};

const Page = styled.main`
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: linear-gradient(135deg, #effcfd 0%, #f8fafc 100%);
  font-family: "Inter", sans-serif;
`;

const Card = styled.section`
  width: min(560px, 100%);
  padding: 44px 34px;
  border: 1px solid #d9eef0;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 22px 65px rgba(17, 94, 99, 0.14);
  text-align: center;

  h1 {
    margin: 16px 0 10px;
    color: #172033;
    font-size: clamp(1.7rem, 4vw, 2.35rem);
  }

  p {
    margin: 0 auto 26px;
    max-width: 440px;
    color: #5b6475;
    font-size: 1.08rem;
    line-height: 1.65;
  }
`;

const LockIcon = styled.div`
  font-size: 3rem;
`;

const RegisterButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 24px;
  border-radius: 999px;
  background: #3bc3cc;
  color: #ffffff;
  font-weight: 800;
  text-decoration: none;
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover {
    background: #172033;
    transform: translateY(-2px);
  }
`;

const BackButton = styled(Link)`
  display: block;
  width: fit-content;
  margin: 18px auto 0;
  color: #64748b;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    color: #172033;
    text-decoration: underline;
  }
`;

export default ImportLicenseGuard;
